var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "inspection-timeline-activity-content" },
    [
      _vm.shouldDisplayCauser
        ? [
            !_vm.activity.causer
              ? _c("span", [_vm._v("Platform")])
              : _vm.activity.causer.business
              ? _c("span", [
                  _vm._v(
                    _vm._s(_vm.activity.causer.full_name) +
                      " (" +
                      _vm._s(
                        _vm.activity.causer.business.name ||
                          "#" + _vm.activity.causer.business.id
                      ) +
                      ")"
                  )
                ])
              : _vm.activity.causer.role === "agent"
              ? _c(
                  "span",
                  [
                    _vm._v("\n      Agent "),
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            name: "app.agents",
                            params: { id: _vm.activity.causer.id }
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.activity.causer.full_name))]
                    )
                  ],
                  1
                )
              : _c("span", [_vm._v(_vm._s(_vm.activity.causer.first_name))])
          ]
        : _vm._e(),
      _vm.activity.type === _vm.$config.inspectionActivityTypes.COMMENT
        ? [
            _vm._v("\n    : "),
            _c("strong", [_vm._v('"' + _vm._s(_vm.activity.comment) + '"')])
          ]
        : _vm.activity.type ===
          _vm.$config.inspectionActivityTypes.TENANT_SCHEDULING_MAIL_SENT
        ? [_c("span", [_vm._v("Tenant scheduling request email sent.")])]
        : _vm.isScheduledByTenant
        ? [
            _c("span", [_vm._v("Schedule chosen by tenant:")]),
            _c("strong", [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.formatDateValue(
                      _vm.newValues.preferred_from,
                      _vm.newValues.preferred_until
                    )
                  ) +
                  "\n    "
              )
            ])
          ]
        : _vm.activity.type === _vm.$config.inspectionActivityTypes.AUDIT
        ? [
            _vm.oldValues.tenant_scheduling_reminders ||
            _vm.newValues.tenant_scheduling_reminders
              ? [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.momentUtil
                          .localeData()
                          .ordinal(
                            _vm.newValues.tenant_scheduling_reminders.length
                          )
                      ) +
                      " reminder to schedule sent to tenants (email & text)\n    "
                  )
                ]
              : _vm._e(),
            _vm.oldValues.tenant || _vm.newValues.tenant
              ? [
                  _vm.oldValues.tenant === null
                    ? [
                        _vm._v("\n        added new tenant: "),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.newValues.tenant.full_name))
                        ])
                      ]
                    : _vm.newValues.tenant === null
                    ? [
                        _vm._v("\n        removed tenant: "),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.oldValues.tenant.full_name))
                        ])
                      ]
                    : [
                        _vm._v(
                          "\n        updated tenant #" +
                            _vm._s(_vm.oldValues.tenant.id) +
                            ":\n        "
                        ),
                        _vm._l(
                          Object.keys(_vm.oldValues.tenant).filter(function(
                            key
                          ) {
                            return key !== "id"
                          }),
                          function(key, index) {
                            return _c("span", [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.resolveValueChangeText("tenant." + key)
                                  )
                                }
                              })
                            ])
                          }
                        )
                      ]
                ]
              : _vm.oldValues.state
              ? [
                  _vm._v("\n      changed status from "),
                  _c("strong", [_vm._v(_vm._s(_vm.oldValues.state))]),
                  _vm._v(" to "),
                  _c("strong", [_vm._v(_vm._s(_vm.newValues.state))])
                ]
              : _vm.hasField("id")
              ? [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.oldValues.id === null ? "ordered" : "cancelled"
                      ) +
                      " report in " +
                      _vm._s(_vm.inspection.property.short_address) +
                      "\n    "
                  )
                ]
              : _vm.hasField("agent_id")
              ? [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.oldValues.agent_id === null
                          ? "assigned"
                          : "unassigned"
                      ) +
                      "\n      agent #" +
                      _vm._s(_vm.oldValues.agent_id || _vm.newValues.agent_id) +
                      "\n      "
                  ),
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.oldValues.full_name || _vm.newValues.full_name)
                    )
                  ])
                ]
              : _vm.hasField("tenant_notified_at")
              ? [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.oldValues.tenant_notified_at === null
                          ? "checked"
                          : "unchecked"
                      ) +
                      " tenants notifications\n    "
                  )
                ]
              : _vm.hasField("brief")
              ? [
                  _vm._v(
                    "\n      sent briefing about this inspection to agent: "
                  ),
                  _c("strong", [_vm._v(_vm._s(_vm.newValues.brief))])
                ]
              : _vm.hasField("report_url")
              ? [
                  _vm._v(
                    "\n      updated the report file from: " +
                      _vm._s(_vm.oldValues.report_url) +
                      " to: " +
                      _vm._s(_vm.newValues.report_url) +
                      "\n    "
                  )
                ]
              : _vm.hasField("tenant_notice_sent_at")
              ? _c("span", [
                  _vm._v(
                    "\n      sent email reminders to tenants about the upcoming inspection.\n      "
                  ),
                  _vm.activity.display_data && _vm.activity.display_data.tenants
                    ? _c("div", [
                        _c("strong", [_vm._v("Tenants: ")]),
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.activity.display_data.tenants
                                .map(function(tenant) {
                                  return (
                                    tenant.full_name + " (" + tenant.email + ")"
                                  )
                                })
                                .join(", ")
                            ) +
                            "\n      "
                        )
                      ])
                    : _vm._e()
                ])
              : _vm.hasField("tenant_reminder_sent_at")
              ? _c("span", [
                  _vm._v(
                    "\n      sent SMS reminders to tenants about the upcoming inspection.\n      "
                  ),
                  _vm.activity.display_data && _vm.activity.display_data.tenants
                    ? _c("div", [
                        _c("strong", [_vm._v("Tenants: ")]),
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.activity.display_data.tenants
                                .map(function(tenant) {
                                  return (
                                    tenant.full_name +
                                    " (" +
                                    tenant.formatted_phone_number +
                                    ")"
                                  )
                                })
                                .join(", ")
                            ) +
                            "\n      "
                        )
                      ])
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._l(Object.keys(_vm.displayableKeys), function(key) {
              return [
                _vm.hasField(key)
                  ? _c("span", {
                      domProps: {
                        innerHTML: _vm._s(_vm.resolveValueChangeText(key))
                      }
                    })
                  : _vm._e()
              ]
            })
          ]
        : _vm._e(),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }